import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import BannerComponent from "../components/politicas_terminos_condiciones/banner.component";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import FooterLayouts from "../layouts/footer.layout";
import AccordionComponent from "../components/politicas_terminos_condiciones/accordion.component";
import TitleComponent from "../components/politicas_terminos_condiciones/title.component";
import { politicasTerminosCondiciones } from "../components/conexion/politica.conexion";

const PoliticasTerminosCondicionesPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [politicas, setPoliticas]: any = useState([]);

  useEffect(() => {
    politicasTerminosCondiciones().then(function (res: any) {
      setPoliticas(res?.data?.data[0]);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active=""
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <div className="home-page-mascara"></div>
        <BannerComponent />
        <TitleComponent />
        <AccordionComponent politicas={politicas} />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default PoliticasTerminosCondicionesPage;
